import { css } from 'styled-components';

import { useTopicCardContext } from 'hb-react/shared/apps/TopicsIndexV2/contexts/TopicCardContext';
import useCustomTopicName from 'hb-react/shared/apps/TopicsIndexV2/hooks/useCustomTopicName';
import ButtonInLink from 'hb-react/shared/components/DesignSystem/ButtonInLink';

export const GoToGroupButtonWithoutContext = ({
  forceDefaultLink = false,
  href,
  target,
  topicName,
}) => {
  const topicCustomName = useCustomTopicName();

  const goToTopicLabel = topicCustomName
    ? s__('Topics|Go To %{topicName}').i__({ topicName: topicCustomName })
    : s__('Topics|Go To Group');

  const ariaLabel = s__('Topics|Go To %{topicName}').i__({ topicName });

  return (
    <ButtonInLink
      wrapperProps={{ width: '100%' }}
      linkProps={{
        to: href,
        forceDefaultLink,
        target,
        style: { textDecoration: 'none', width: '100%' },
      }}
      buttonProps={{
        variant: 'secondary',
      }}
      css={css`
        width: 100%;
      `}
      aria-label={ariaLabel}
    >
      {goToTopicLabel}
    </ButtonInLink>
  );
};

const GoToGroupButton = () => {
  const { forceDefaultLink, href, target, topic } = useTopicCardContext();

  return (
    <GoToGroupButtonWithoutContext
      forceDefaultLink={forceDefaultLink}
      href={href}
      target={target}
      topicName={topic?.name}
    />
  );
};

export default GoToGroupButton;
